import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import InventoryInputBatch from "../../models/inventory-input-batch";

interface InventoryInputBatchDeleteModalProps {
  show: boolean;
  item?: InventoryInputBatch;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const InventoryInputBatchDeleteModal: React.FC<
  InventoryInputBatchDeleteModalProps
> = ({ show, item, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const message = item
    ? `Está seguro de que quiere eliminar el batch #${item.id}`
    : "";

  const onDeleteClick = async () => {
    if (item !== undefined) {
      setSubmitting(true);
      const requestStatus = await deleteItem<InventoryInputBatch>(
        `/inventory_locations/batches/${item.id}/`,
        item
      );

      if (requestStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (requestStatus.detail !== undefined) {
          message = requestStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default InventoryInputBatchDeleteModal;
